const BYTES_PER_KILOBYTE = 1024;
export const BYTES_PER_MEGABYTE = 1024 * BYTES_PER_KILOBYTE;

export const formatFileSize = (sizeInBytes: number, language: string) => {
  const isMegabytes = sizeInBytes >= BYTES_PER_MEGABYTE;
  const sizeInMegabytes = sizeInBytes / BYTES_PER_MEGABYTE;
  const sizeInKilobytes = Math.max(1, sizeInBytes / BYTES_PER_KILOBYTE);
  const sizeInUnit = isMegabytes ? sizeInMegabytes : sizeInKilobytes;
  return new Intl.NumberFormat(language, {
    style: "unit",
    unit: isMegabytes ? "megabyte" : "kilobyte",
    maximumFractionDigits: isMegabytes ? 1 : 0,
  }).format(sizeInUnit);
};
